<template>
	<div class="list-item">
		<div class="head-box">
			<img class="imgs" :src="head" />
			<div v-if="readState <= 0" class="item-badge"></div>
		</div>
		<div class="content-detail">
			<p class="ps">{{typeText}}<span class="spans">{{time}}</span></p>
			<p class="ps" @click="orderDet">{{content}}</p>
		</div>
		<div v-if="showBtn" class="contract-btn">
			<div v-if="messageType !== 3" class="content-div"
				:class="messageType === 2 ? (readState >= 1 ? 'filter-btn' : '') : ''" @click="componentClick">
				<i v-if="!!icon" :class="icon"></i>
				{{btnText?btnText:$t('messageCenter.communicate')}}
			</div>
			<a :href="link" target="_blank" v-if="messageType === 3" @click="componentClick" class="content-div"
				:class="messageType === 2 ? (readState >= 1 ? 'filter-btn' : '') : ''">
				<i v-if="!!icon" :class="icon"></i>
				{{btnText?btnText:$t('messageCenter.communicate')}}
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: "MessageItem",
		methods: {
			// 成品订单详情
			orderDet() {
				if (this.orderNo) {
					this.$router.push(
						`/order/orderDetail?id=${this.orderNo}&type=${this.orderType == 1?0:1}`
					);
				}
			},
			componentClick() {
				if (this.messageType === 2 && this.readState >= 1) return;
				this.$emit('componentClick', {
					messageType: this.messageType,
					entityId: this.entityId,
					index: this.index
				});
			},
		},
		props: {
			orderType: {
				type: Number,
				default: 0
			},
			orderNo: {
				type: String,
				default: ''
			},
			link: {
				type: String,
				default: ''
			},
			index: {
				type: Number,
				default: 0
			},
			entityId: {
				type: String,
				default: ''
			},
			content: {
				type: String,
				default: '暂无内容...'
			}, //内容
			time: {
				type: String,
				default: ''
			}, //时间
			head: {
				type: String,
				default: require('../../../assets/images/logo.png')
			}, //头像
			typeText: {
				type: String,
				default: '公告'
			}, //公告处的文字
			btnText: {
				type: String,
				default: ''
			}, //按钮文字
			icon: {
				type: String,
				default: ''
			}, //图标
			showBtn: {
				type: Boolean,
				default: false
			}, //是否显示按钮
			readState: {
				type: Number,
				default: 1
			},
			messageType: {
				type: Number,
				default: -1
			} //消息类型
		}
	}
</script>

<style scoped>
	.list-item {
		display: flex;
		width: 90.3%;
		margin: 0 auto;
		padding: 20px 0;
		border-bottom: 1px solid #e7e7e7;
	}

	.list-item>.content-detail {
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	.list-item>.content-detail>.ps {
		text-align: left;
		font-size: 14px;
		line-height: 27px;
	}

	.list-item>.content-detail>.ps:nth-child(1) {
		color: #999999;
	}

	.list-item>.content-detail>.ps:nth-child(1)>.spans {
		margin-left: 15px;
	}

	.list-item>.imgs {
		width: 48px;
		height: 48px;
	}


	.head-box>.imgs {
		width: 50px;
		height: 50px;
	}

	.head-box {
		position: relative;
		margin-right: 10px;
	}

	.item-badge {
		background: red;
		width: 5px;
		height: 5px;
		border-radius: 50%;
		position: absolute;
		right: 0;
		top: 0;
	}

	/*btn*/
	.contract-btn {
		display: flex;
		align-items: center;
		margin-left: 50px;
	}

	.contract-btn>.content-div {
		width: 103px;
		color: #fff;
		height: 20px;
		line-height: 20px;
		text-align: center;
		padding: 3px 5px;
		background: linear-gradient(0deg, rgba(5, 115, 203, 1) 0%, rgba(63, 159, 234, 1) 100%);
	}

	.filter-btn {
		filter: grayscale(100%);
	}
</style>



// WEBPACK FOOTER //
// src/components/memberCenter/message/MessageItem.vue